<template>
  <div class="dingdan">
    <Breadtabsheader/>

    <!--查询-->
    <div class="h-piece h-mrt30 margin">
      <div class="h-formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="供应商名称" prop="customerName">
              <el-input v-model="formInline.customerName" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="国科全名" prop="companyName">
              <el-input v-model="formInline.companyName" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="产品编码/名称" prop="productCodeNameLike">
              <el-input v-model="formInline.productCodeNameLike" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="产品线名称" prop="productLineName">
              <el-input v-model="formInline.productLineName" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
          </div>
          <el-collapse-transition>
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="规格型号" prop="specificationModel">
                  <el-input v-model="formInline.specificationModel" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <!--查询end-->

    <!--列表-->
    <div class="h-table h-mrt30 tableclslist">
      <el-table
          ref="ddtable"
          :data="tableData"
          stripe
          border
          :show-overflow-tooltip="true"
          style="width: 100%"
          max-height="450"
      >
        <el-table-column
            fixed
            prop="customerName"
            label="供应商名称"
            :show-overflow-tooltip="true"
            width="250">
        </el-table-column>
        <el-table-column
            prop="companyName"
            label="国科全名"
            fixed
            :show-overflow-tooltip="true"
            width="250">
        </el-table-column>
        <el-table-column
            prop="productCode"
            label="产品编码"
            fixed
            width="120">
        </el-table-column>
        <el-table-column
            prop="productName"
            label="产品名称"
            fixed
            :show-overflow-tooltip="true"
            width="200">
        </el-table-column>
        <el-table-column
            prop="productLineName"
            label="产品线名称"
            :show-overflow-tooltip="true"
            width="200">
        </el-table-column>
        <el-table-column
            prop="unit"
            label="国科单位"
            min-width="100">
        </el-table-column>
        <el-table-column
            prop="inventoryNumber"
            label="库存数量"
            width="100">
        </el-table-column>
        <el-table-column
            prop="inventoryAmount"
            label="采购未税价格"
            width="120">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.inventoryAmount}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="inventoryCaptureDate"
            label="库存截取时间"
            :show-overflow-tooltip="true"
            width="120">
        </el-table-column>
        <el-table-column
            prop="specificationModel"
            label="规格型号"
            :show-overflow-tooltip="true"
            width="200">
        </el-table-column>
        <el-table-column
            prop="warehouseName"
            label="仓库名称"
            :show-overflow-tooltip="true"
            width="200">
        </el-table-column>
        <el-table-column
            prop="purchaseInventoryDate"
            label="采购入库日期"
            :show-overflow-tooltip="true"
            width="110">
        </el-table-column>
        <el-table-column
            prop="effectiveDate"
            label="生效日期"
            :show-overflow-tooltip="true"
            width="110">
        </el-table-column>
        <el-table-column
            prop="expiringDate"
            label="失效日期"
            width="110">
        </el-table-column>
      </el-table>
      <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
        <pagination :page="formInline" @query="query"/>
        <div style="display:flex;align-items: center;">
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                     @click="exportExcel">导出
          </el-button>
        </div>
      </div>
    </div>
    <!--列表end-->
  </div>
</template>
<script>
import ss from '../../api/SystemService'
export default {
  data(){
    return{
      formInline: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        customerName: null,  //供应商名称
        companyName: null,//国科全名
        productCodeNameLike: null,  //产品编码或名称
        productLineName: null, //产品线名称
        specificationModel: null, //规格型号
      },
      tableData: []
    }
  },
  created() {
    this.query()
  },
  methods:{
    // 展开折叠
    collapseChange(){
      this.isScreen = !this.isScreen;
    },
    //检索
    handleFilter(){
      this.formInline.pageNo = 1;
      this.query();
    },
    //重置
    resetData(){
      this.formInline = {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.query()
    },
    query(){
      ss.GKOrderPage.InventoryListPage(this.formInline).then(res=>{
        this.tableData = res.records;
        this.formInline.total = res.total || 0;
      })
    },
    //导出
    exportExcel(){
      let param = {
        customerName: this.formInline.customerName,  //供应商名称
        companyName: this.formInline.companyName,//国科全名
        productCodeNameLike: this.formInline.productCodeNameLike,  //产品编码或名称
        productLineName: this.formInline.productLineName, //产品线名称
        specificationModel: this.formInline.specificationModel, //规格型号
      }
      ss.GKOrderPage.ExportInventoryList(param).then(res => { // 处理返回的文件流
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', `国科库存.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(function (error) {
        console.log("导出错误",error.toString())
      });
    }
  }
}
</script>
<style scoped>
.xiangmu .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 1rem !important;
}

.D-date .el-cascader {
  line-height: 0;
}
.tableclslist	.h-tableLink{
  padding:0px 2px!important;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__label{
  width: 20%;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__content{
  width: 80%;
}
</style>